import React from 'react';

import { Icon } from '@chakra-ui/react';

export const DisableIcon = props => (
  <Icon viewBox="0 0 24 24" w="full" h="full" color="inherit" {...props}>
    <path d="M5.99936007,18.7077467 C7.59170608,20.1332071 9.69462788,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,9.69462788 20.1332071,7.59170608 18.7077467,5.99936007 L5.99936007,18.7077467 L5.99936007,18.7077467 Z M5.29225329,18.0006399 L18.0006399,5.29225329 C16.4082939,3.86679291 14.3053721,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,14.3053721 3.86679291,16.4082939 5.29225329,18.0006399 L5.29225329,18.0006399 Z M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z" />
  </Icon>
);
